/**
 * The mapping of locale codes from our supported locales to the format expected by date-fns in blueprint DatePicker component
 */
export const localeMap: Record<string, string> = {
  en: 'en-AU',
  es: 'es',
  pt: 'pt',
  zh: 'zh-CN',
  fr: 'fr',
  lt: 'lt',
  vi: 'vi',
} as const;
